import { render } from "./background_update_component.vue?vue&type=template&id=df09a1ee&scoped=true"
import script from "./background_update_component.vue?vue&type=script&lang=js"
export * from "./background_update_component.vue?vue&type=script&lang=js"

import "./background_update_component.vue?vue&type=style&index=0&id=df09a1ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df09a1ee"]])

export default __exports__